<template>
    <div class="table-control col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">

        <el-select v-if="paging && paging.perPageOptions"
            class="select-primary mb-3 pagination-select"
            v-model="paging.perPage"
            placeholder="Per page">

            <el-option
                class="select-primary"
                v-for="item in paging.perPageOptions"
                :key="item"
                :label="item"
                :value="item">
            </el-option>

        </el-select>

        <form @submit.prevent="submit" v-if="search">
            <base-input v-model="searchValue"
                prepend-icon="fas fa-search"
                :placeholder="$t('common.search')"
            >
            </base-input>
        </form>

    </div>
</template>

<script>
    export default {

        props: {
            paging: {
                type: Object,
                required: false
            },
            search: {
                type: Boolean,
                default: false
            },
            value: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                searchValue: ''
            }
        },

        methods: {

            clearFilter() {
                this.searchValue = ''
            },

            setFilter(value) {
                this.searchValue = value
            },

            submit() {
                this.$emit('input', this.searchValue.trim())
            }
        }
    }
</script>
